import React, { FC } from 'react';
import classes from '../../styles/index.module.scss';
import classNames from 'classnames';
import { ModalContainerProps } from '../../../../../../ReactSharedScripts/components/ModalBox/types';

export const Container: FC<React.PropsWithChildren<ModalContainerProps>> = ({ children, className, dataTestId }) => {
	const componentClasses = classNames(classes.container, className);

	return (
		<div
			className={componentClasses}
			data-testid={dataTestId}
		>
			{children}
		</div>
	);
};
